import { useMediaQuery } from '@material-ui/core';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useRouteMatch } from 'react-router-dom';

import { AppHeader } from '~/common/header';
import { NavBlock } from '~/common/nav-drawer';
import { AppNotification } from '~/common/notifications';
import { features } from '~/features';
import * as AuthFeature from '~/features/auth';
import * as DashboardFeature from '~/features/dashboard';
import * as CreatorsListFeature from '~/features/creators-list';
import { toggleNawDrawerAction } from '~/features/dashboard/store/actions';
import { selectNawDrawerState } from '~/features/dashboard/store/selectors';
import { selectAuthorizedState } from '~/store/user/selectors';
import { mediaQuery } from '~/styles/media-query';
import { getUserProfile } from '~/features/dashboard/store/actions.thunks';

export const AppRouter = () => {
    const isAuthorized = useSelector(selectAuthorizedState);

    const AuthRouter = features[AuthFeature.name].FeatureRouter;

    const location = useLocation();

    const dispatch = useDispatch();

    const isDesktop = useMediaQuery(mediaQuery.desktop);

    const isNawBarOpened = useSelector(selectNawDrawerState);

    const isNawBarOpenedRef = useRef(isNawBarOpened);

    const isAuthRoute = useRouteMatch(features[AuthFeature.name].FEATURE_ROUTER_PATH);

    useEffect(() => {
        isNawBarOpenedRef.current = isNawBarOpened;
    }, [isNawBarOpened]);

    useEffect(() => {
        if (isDesktop) {
            return;
        }

        if (!isNawBarOpenedRef.current) {
            return;
        }
        dispatch(toggleNawDrawerAction(false));
        dispatch(getUserProfile());
    }, [dispatch, isDesktop, location]);

    const isDashboardRoute = useRouteMatch(features[DashboardFeature.name].FEATURE_ROUTER_PATH);

    return (
        <>
            {!isAuthRoute && <AppHeader />}
            {!isDashboardRoute && !isDesktop && <NavBlock />}
            {!isAuthorized ? <AuthRouter /> : <CreatorsListFeature.FeatureRouter />}
            <AppNotification />
        </>
    );
};
